import "../index.css";
import { useEffect } from "react";
import Footer from "../components/Footer";
//import { useAuth } from "../auth/context";
import { PageNav } from "../components/PageNav";

export default function About() {
  //   const { user, loading } = useAuth();

  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <PageNav />
      <div className="main_div">
        <div className="center_me">
          <div
            style={{
              maxWidth: 800,
              width: "100%",
              padding: "20px",
            }}
          >
            {/* Why Stake Alerts Section */}
            <div
              className=""
              style={{
                borderRadius: 12,
                //                padding: 30,
                marginBottom: 30,
              }}
            >
              <div
                className=""
                style={{
                  borderRadius: 8,
                  padding: 20,
                  marginBottom: 20,
                  textAlign: "center",
                }}
              >
                <h2
                  className="font_family_base header_text"
                  style={{
                    fontSize: 28,
                    fontWeight: "bold",
                    margin: 0,
                  }}
                >
                  Why Stake Alerts
                </h2>
              </div>
              <div
                className=""
                style={{
                  borderRadius: 8,
                  padding: 20,
                }}
              >
                <p
                  className="font_family_base detail_text"
                  style={{
                    fontSize: 16,
                    lineHeight: 1.6,
                    textAlign: "center",
                    margin: 0,
                  }}
                >
                  At StakeAlerts, we are committed to simplifying the betting
                  experience. Our platform empowers users to discover and act on
                  their preferred betting opportunities without the
                  time-consuming process of manual research or navigating
                  multiple applications. We provide a centralized, reliable, and
                  user-focused solution that saves time and enhances
                  decision-making.
                </p>
              </div>
              <div
                className=""
                style={{
                  borderRadius: 8,
                  padding: 20,
                  marginBottom: 20,
                  textAlign: "center",
                }}
              >
                <h2
                  className="font_family_base header_text"
                  style={{
                    fontSize: 28,
                    fontWeight: "bold",
                    margin: 0,
                  }}
                >
                  About Us
                </h2>
              </div>
              <div
                className=""
                style={{
                  borderRadius: 8,
                  padding: 20,
                }}
              >
                <p
                  className="font_family_base detail_text"
                  style={{
                    fontSize: 16,
                    lineHeight: 1.6,
                    textAlign: "center",
                    margin: 0,
                  }}
                >
                  We are a group of sports enthusiasts with a love for prop
                  betting. What started as a personal project to improve our
                  personal experience has grown into a chance to share our
                  passion project with the world and simplify the betting
                  process for all our customers.
                </p>
              </div>
            </div>

            {/* Images Section */}
            <div className="center_me">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 20,
                  alignItems: "center",
                }}
              >
                {/* Note: Add your images here when they're available */}
                {/* <img
                  src="/assets/images/dummy1.png"
                  alt="Promo 1"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
                <img
                  src="/assets/images/dummy2.png"
                  alt="Promo 2"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
